module.exports = __webpack_public_path__ + "media/components/journeys/ticket-icons/road-blocked-44876506f48423c3cb780d9553e91ae9.png";